<template>
  <v-card flat width="100%">
    <v-card-title>Change CLI</v-card-title>

    <template>
      <v-card-text>
        <div class="mb-5">
          <div>Existing CLI</div>
          <b>{{(product.product_details || {}).line_number}}</b>
        </div>
        <v-text-field label="New CLI/Service ID" :disabled="changeCliLoading" v-model="line_number" :error-messages="linNumberError" @input="$v.line_number.$touch()" @blur="$v.line_number.$touch()" outlined dense></v-text-field>
        <v-select label="Change Reason" :disabled="changeCliLoading||telcoCliChangeReasonsLoading" v-model="change_reason" :error-messages="changeReasonError" @input="$v.change_reason.$touch()" @blur="$v.change_reason.$touch()" outlined dense :loading="telcoCliChangeReasonsLoading" :items="telcoCliChangeReasons.map(x => x.value)"></v-select>
    
        <template v-if="isLegacyTariff">
          <v-alert color="error" colored-border border="right" dense elevation="2">
            <template #prepend>
              <v-icon large color="error" class="mr-6">{{ mdiAlert }}</v-icon>
            </template>

            <div>Legacy tariff: Billing will need to be updated manually to reflect the new CLI</div>
          </v-alert>
        </template>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="submit()" :disabled="this.$v.line_number.$dirty && !this.$v.change_reason.required" :loading="changeCliLoading">Save</v-btn>
        <v-btn color="primary" small outlined class="ml-3" @click="close">Close</v-btn>
      </v-card-actions>
    </template>
  </v-card>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { mapActions, mapGetters, mapState } from "vuex";
import { mdiAlert } from '@mdi/js';

const
  isValidServiceID = val => {
    return /^[a-zA-Z]{4}[0-9]{8}$/.test(val);
  },
  isLineNumberStartWithZero = val => {
    return val.charAt(0) === '0';
  },
  isStringContainsOnlyDigits = val => {
    return /^\d+$/.test(val);
  },
  is10Or11DigitsLong = val => {
    let length = val.length;
    return length >= 10 && length <= 11;
  };

export default {
  mixins: [validationMixin],

  validations() {
    let line_number_ext;
    if (this.isFTTP) {
      line_number_ext = { isValidServiceID };
    } else {
      line_number_ext = {
        isLineNumberStartWithZero,
        isStringContainsOnlyDigits,
        is10Or11DigitsLong,
      };
    }
    return {
      line_number: { required, ...line_number_ext },
      change_reason: { required },
    }
  },

  props: ['product', 'dialogOpen'],

  data: () => ({
    changeCliLoading: false,
    line_number: '',
    change_reason: '',
    checkTariff: true,
    mdiAlert,
  }),

  computed: {
    ...mapState("products", ["currentProduct"]),
    ...mapState('productCli', ['telcoCliChangeReasons', 'telcoCliChangeReasonsLoading']),
    ...mapGetters('products', ['getTariffs', 'getAllTariffsLoading', 'getCurrentProduct']),

    linNumberError() {
      const errors = [];
      let line_number = this.$v.line_number;
      if (!line_number.$dirty) return errors;
      !line_number.required && errors.push('Line number is a required field');
      if (this.isFTTP) {
        !line_number.isValidServiceID && errors.push('The Service ID is not valid');
      } else {
        !line_number.isLineNumberStartWithZero && errors.push('Must start with 0');
        !line_number.isStringContainsOnlyDigits && errors.push('Must be only numbers');
        !line_number.is10Or11DigitsLong && errors.push('Must be 10 or 11 digits long');
      }
      return errors;
    },

    changeReasonError() {
      const errors = [];
      if (!this.$v.line_number.$dirty) return errors;
      !this.$v.change_reason.required && errors.push('Please select a reason for this change');
      return errors;
    },

    isLegacyTariff() {
      return this.getCurrentProduct.tariff_version === 'TARIFF_V1';
    },

    isLoading() {
      return [this.getAllTariffsLoading, this.telcoCliChangeReasonsLoading].includes(true);
    },

    isFTTP() {
      let tariff = this.getTariffs.find(tariff => tariff.id === this.product.tariff_id);
      if(tariff && tariff.service === "FTTP") return true;
      return false;
    },
  },

  methods: {
    ...mapActions('products', ['getAllTariffs']),
    ...mapActions('productCli', ['changeCli', 'getTelcoCliChangeReasons']),

    async submit() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      this.changeCliLoading = true;
      try {
        await this.changeCli({
          productId: this.product.id,
          data: {
            line_number: this.line_number,
            change_reason: this.change_reason}
        });
        this.close();
        this.changeCliLoading = false;
      } catch(e) {
        this.changeCliLoading = false;
      }
    },

    close() {
      this.resetForm();
      this.$emit('close');
    },

    resetForm() {
      this.line_number = '';
      this.change_reason = '';
      this.$v.$reset();
    },
  }
};
</script>

<style lang="scss" scoped></style>
